import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';

export function OrderRestored(props: TypicalMessageProps) {
    return <TypicalMessage model={props.model} options={props.options}/>;
}
